export default "__VITE_ASSET__BydegsjX__"